/* unplugin-vue-components disabled */import { render } from "./chat-input.vue?vue&type=template&id=16679840&scoped=true"
import script from "./chat-input.vue?vue&type=script&lang=js"
export * from "./chat-input.vue?vue&type=script&lang=js"

import "./chat-input.vue?vue&type=style&index=0&id=16679840&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16679840"],['__file',"src/components/chat-input-v2/chat-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16679840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16679840', __exports__)) {
    api.reload('16679840', __exports__)
  }
  
  module.hot.accept("./chat-input.vue?vue&type=template&id=16679840&scoped=true", () => {
    api.rerender('16679840', render)
  })

}


export default __exports__